var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderManagementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.625C0 0.45924 0.0658481 0.300268 0.183058 0.183058C0.300269 0.065848 0.45924 0 0.625 0H11.875C12.0408 0 12.1997 0.065848 12.3169 0.183058C12.4342 0.300268 12.5 0.45924 12.5 0.625V6.875H11.25V1.25H1.25V16.25H5V17.5H0.625C0.45924 17.5 0.300269 17.4342 0.183058 17.3169C0.0658481 17.1997 0 17.0408 0 16.875V0.625ZM10 5H2.5V3.75H10V5ZM7.5 7.5H2.5V6.25H7.5V7.5ZM9.375 10V8.75H10.625V10H12.5V11.25H9.375C9.0325 11.25 8.75 11.5325 8.75 11.875C8.75 12.2175 9.0325 12.5 9.375 12.5H10.625C11.6575 12.5 12.5 13.3425 12.5 14.375C12.5 15.4075 11.6575 16.25 10.625 16.25V17.5H9.375V16.25H7.5V15H10.625C10.9675 15 11.25 14.7175 11.25 14.375C11.25 14.0325 10.9675 13.75 10.625 13.75H9.375C8.3425 13.75 7.5 12.9075 7.5 11.875C7.5 10.8425 8.3425 10 9.375 10ZM5 13.75H2.5V12.5H5V13.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderManagementIcon);
export default __webpack_public_path__ + "static/media/order-management-icon.5355a3a7b4fecc77ac77eb98cba17a3f.svg";
export { ForwardRef as ReactComponent };